<script>
import CTA from '@maison/components/common/CTA';
import LoadMoreButton from '@maison/components/search/LoadMoreButton';
import { PhxPicture } from '@phx-styleguides/pia';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import RelatedLinks from '../relatedLinks/RelatedLinks';

export default {
  components: {
    PhxsgButton,
    CTA,
    PhxPicture,
    RelatedLinks,
    LoadMoreButton,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    alignedCenter: {
      type: Boolean,
      default: false,
    },
    filteredColumns: {
      type: Array,
      required: true,
    },
    shouldDisplayLoadMore: {
      type: Boolean,
      default: false,
    },
    ctas: {
      type: Array,
      default: () => [],
    },
    relatedLinks: {
      type: Array,
      default: () => [],
    },
    headingTag: {
      type: String,
      default: 'h2',
    },
    headingClass: {
      type: String,
      default: 'h2',
    },
    getColumnClasses: {
      type: Function,
      required: true,
    },
    getColumnData: {
      type: Function,
      required: true,
    },
    getComponent: {
      type: Function,
      required: true,
    },
    nextPage: {
      type: Function,
      default: () => {},
    },
    seeAll: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<template>
  <section class="theme--light section section--top-false section--y-xs">
    <div class="container container--lg section--y-xs">
      <div v-if="title" class="headings headings--centered">
        <component :is="headingTag" :class="headingClass">{{ title }}</component>
        <h3 v-if="subtitle" class="headings__subtitle">{{ subtitle }}</h3>
      </div>
      <div ref="grid" data-cy="mixed-grid" :class="['mixed-grid', { 'mixed-grid--center': alignedCenter }]">
        <div v-for="column in filteredColumns" :key="column.data.itemId" :class="getColumnClasses(column)">
          <component
            :is="getComponent(column.template)"
            v-bind="getColumnData(column)"
            :sizes="column.sizes"
            data-cy="mixed-grid-item"
            :data-cy-item="column.template"
          >
          </component>
        </div>
      </div>
      <ul v-if="shouldDisplayLoadMore" class="actions actions--centered mt-base lg:mt-lg" role="presentation">
        <li role="presentation">
          <load-more-button data-cy="mixed-grid-load-more" @click="nextPage" />
        </li>
        <li role="presentation">
          <PhxsgButton data-cy="mixed-grid-see-all" variant="plain" color="secondary" @click="seeAll">
            {{ $t('Button.seeAll') }}
          </PhxsgButton>
        </li>
      </ul>
      <ul
        v-else-if="ctas.length"
        class="actions actions--centered mt-base lg:mt-lg"
        role="presentation"
        data-cy="mixed-grid-ctas"
      >
        <li v-for="(cta, index) in ctas" :key="index" role="presentation">
          <c-t-a v-bind="cta" />
        </li>
      </ul>
      <related-links :list="relatedLinks" />
    </div>
  </section>
</template>
